import React from "react";
import { SelectOptionIcon } from "./selectOptionIconHelpers";

export const getButtonOptionIcons = (selectOptionsIcons?: Record<string, string>) => {
  return selectOptionsIcons || {};
};

export const getButtonOptionIcon = (
  option?: string | null,
  selectOptionsIcons?: Record<string, string>
) => {
  const value = `${option ?? ""}`;

  return getButtonOptionIcons(selectOptionsIcons)?.[value] || "";
};

export const getPrunedButtonOptionIcons = (
  values: string[] = [],
  selectOptionsIcons?: Record<string, string>
) => {
  return values.reduce((optionIcons: Record<string, string>, option) => {
    const value = `${option ?? ""}`;
    const icon = getButtonOptionIcon(option, selectOptionsIcons);

    if (value && icon) {
      optionIcons[value] = icon;
    }

    return optionIcons;
  }, {});
};

export const getButtonInputOptions = (
  options?: string[],
  selectOptionsIcons?: Record<string, string>
) => {
  return (
    options?.map((option) => {
      const value = `${option ?? ""}`;
      const icon = getButtonOptionIcon(option, selectOptionsIcons);

      return {
        value,
        label: icon ? (
          <span className="d-inline-flex align-items-center gap-2">
            <SelectOptionIcon
              icon={icon}
              width={18}
              className="flex-shrink-0"
            />
            <span>{value}</span>
          </span>
        ) : (
          value
        ),
      };
    }) || []
  );
};
